import data from './data'
import components from './components'

export default {
  data,
  components,
  resourcePath: '/v1/professional/companies/companies'
}



// WEBPACK FOOTER //
// ./src/app/professional/company/companies/resources/index.js